export default function ($scope, getVMCAccountDisplayList, openAddAccountGroupModal, openAddVmcAccountModal) {
    const vm = this;

    vm.isFetchingRecords = false;
    vm.errorsOccured = false;
    vm.noRecords = false;
    vm.dealers = [];
    vm.hasMoreData = true;
    vm.pageNumber = 0;
    vm.filter = '';

    vm.loadMoreDealers = loadNextPage;
    vm.loadPreviousPage = loadPreviousPage;
    vm.searchDealer = applySearchCriteria;
    vm.addGroup = addAccountGroup;
    vm.addVmcAccount = addVmcAccount;
    vm.canGoToNextPage = canGoToNextPage;
    vm.canGoToPreviousPage = canGoToPreviousPage;

    /* --- */

    resetDealers();

    /* --- */

    function applySearchCriteria() {
        vm.noRecords = false;
        vm.errorsOccured = false;
        vm.pageNumber = 0;
        resetDealers();
    }

    function resetDealers() {
        vm.hasMoreData = true;
        vm.dealers = [];
        vm.pageNumber = 0;
        loadNextPage();
    }

    function canGoToNextPage() {
        return vm.hasMoreData;
    }

    function loadNextPage() {
        if (vm.hasMoreData) {
            requestDealers(vm.pageNumber + 1);
        }
    }

    function canGoToPreviousPage() {
        return vm.pageNumber > 1;
    }

    function loadPreviousPage() {
        if (vm.pageNumber === 1) {
            return;
        }
        requestDealers(vm.pageNumber - 1);
    }

    function addAccountGroup() {
        openAddAccountGroupModal();
    }

    function requestDealers(pageNumber) {
        vm.pageNumber = pageNumber;
        vm.isFetchingRecords = true;

        getVMCAccountDisplayList(pageNumber, vm.filter)
            .then(data => {
                // prevent paging jump if request don't resolve in order
                if (vm.pageNumber !== pageNumber) {
                    return;
                }

                vm.isFetchingRecords = false;
                vm.dealers = data.dealers;
                vm.hasMoreData = data.hasMoreData;

                vm.noRecords = vm.dealers.length === 0;
            })
            .catch(() => {
                vm.isFetchingRecords = true;
                vm.errorsOccured = true;
            });
    }

    function addVmcAccount() {
        openAddVmcAccountModal();
    }
}



// WEBPACK FOOTER //
// ./Client/app/dealer/controllers/list/vmcAccountListCtrl.js